import http from '../utils/http-common';
import {
  AuthResponse,
  CheckSessionResponse,
  LoginInput,
} from '../types/auth.types';
import { ChangePassInput } from '../types/user.types';
import { APIResponse } from '../types/api-response.type';

const headers = {
  Accept: 'application/json, text/plain, */*',
  'Content-Type': 'application/json',
  Authorization: `Bearer qIH81df9WTWvTr5zLAwJxS7cJ4EuCpTp2UyUXwOGlSxVU11dT2b93ZdTCFtXadsA`,
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'GET,POST,PATCH,OPTIONS',
};

const signIn = (data: LoginInput) => {
  return http.post<AuthResponse>('/admin/auth/signin', data);
};

const changePassword = (data: ChangePassInput) => {
  return http.put<APIResponse>('/admin/auth/change-password', data);
};

const checkSession = (sessionId: string) => {
  return http.post<CheckSessionResponse>(`admin/auth/check-session`, {sessionId});
}

const signOut = () => {
  return http.post<APIResponse>(`admin/auth/signout`);
}

const AuthService = {
  signIn,
  changePassword,
  checkSession,
  signOut
};

export default AuthService;
